import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DoctorsService} from '../../../../services/doctors.service';
import {OfficeLocationsService} from '../../../configuration/office-locations/office-locations.service';
import {Globals} from '../../../../globals';
import {MatRadioChange} from '@angular/material/radio';
import {StaticDataService} from '../../../../services/static-data.service';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {UntypedFormControl} from '@angular/forms';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {ReportFinancialFilterModel} from '../../models/ReportFinancialFilterModel.model';
import Utils from '../../Utils/utils';
import {DataRangesEnum} from "../../../../models/enum/Date-Ranges.enum";


@Component({
  selector: 'app-report-financial-summary-filter',
  templateUrl: './report-financial-summary-filter.component.html',
  styleUrls: ['./report-financial-summary-filter.component.scss']
})
export class ReportFinancialSummaryFilterComponent implements OnInit {
  doctorSelected: DoctorDataModel;
  selectedDateRanges: EnumValidValueItemModel;
  doctor = new UntypedFormControl();
  filterDateRangesEnums: EnumValidValueItemModel[] = [];
  reportFinancialFilterModel: ReportFinancialFilterModel;
  startDate: any;
  endDate: any;
  selectedClient: any;
  isDateRangeDefined: boolean = false;
  isCurrentMonth: boolean = false;
  clientList: any;
  isReportForProvide: boolean = false;
  @Output() newItemEvent = new EventEmitter<any>();

  constructor(public staticDataService: StaticDataService,
              public doctorService: DoctorsService,
              public locService: OfficeLocationsService,
              public globals: Globals) { }

  ngOnInit(): void {

    this.loadServiceData();
  }


  radioChange(event: MatRadioChange) {
    event.value === 'true' ? this.isReportForProvide = true : this.isReportForProvide = false;
  }

  onChangeClient(event) {
    this.selectedClient = event.value;
  }

  onDoctorSelect(doctor: DoctorDataModel, event: any) {
    if (event.isUserInput) {
      this.doctorSelected = doctor;
    }
  }

  onChangeDateRanges(event) {
    this.selectedDateRanges = event.value;
    this.setDatesRanges();
  }

  setDatesRanges(){
    this.isDateRangeDefined = true;
    const {startDate, endDate, isCurrentMonth} = Utils.getDataRange(this.selectedDateRanges.ValidValueItemId);
    this.startDate = startDate;
    this.endDate = endDate;
    this.isCurrentMonth = isCurrentMonth;
  }

  loadServiceData() {
    this.locService.getClients().subscribe(data => {
      this.clientList = data;
      if (this.clientList.length > 0) {
        // Try to locate current users client
        this.selectedClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      }
     }, err => {
      console.log(err);
    });
    this.filterDateRangesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumIOFilterDateRanges');
    // set default parameters
    this.selectedDateRanges  = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.Today);
    this.setDatesRanges();
  }

  sendFilterToParent(){
    /*this.reportFinancialFilterModel = new ReportFinancialFilterModel();
    // check filter for provider or practice
    if ( this.isReportForProvide){
      if (this.doctorSelected === undefined || this.selectedDateRanges === undefined){
        return;
      } else{
      this.reportFinancialFilterModel.ProviderId = this.doctorSelected.DoctorId;
      }
    }else if (this.selectedClient === undefined || this.selectedDateRanges === undefined){
      return;
    }else
    { this.reportFinancialFilterModel.PracticeId = this.selectedClient.TDOCID; }
    this.reportFinancialFilterModel.isCurrentMonth = this.isCurrentMonth;
    this.reportFinancialFilterModel.initialDate = this.startDate;
    this.reportFinancialFilterModel.endDate = this.endDate;
    this.newItemEvent.emit(this.reportFinancialFilterModel);*/
  }

  UserDefined() {
    // set User Defined parameters
    this.selectedDateRanges  = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.UserDefined);
  }

}
